export default __webpack_public_path__ + "static/media/q_wdt_c_4.f920aded.mp3";